import React from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import theme from "styles/theme"
import markupSuperscripts from "lib/markupSuperscripts"

const Footnotes = ({ children }) => (
  <div
    css={{
      listStyle: "none",
      margin: "30px 0 0",
      padding: "10px 0 0",
      fontSize: 12,
      fontStyle: "italic",
      lineHeight: 1.6,
      color: theme.gray,
      borderTop: `1px solid ${theme.softGray}`,
      [theme.mobile]: {
        marginTop: 20,
      },
    }}
  >
    {React.Children.map(children, (note, index) => (
      <Footnote key={index}>{note}</Footnote>
    ))}
  </div>
)

export default Footnotes

Footnotes.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
}

const Footnote = ({ children }) => (
  <div>
    <Markdown options={{ forceInline: true }}>
      {markupSuperscripts(children)}
    </Markdown>
  </div>
)

Footnote.propTypes = {
  children: PropTypes.string.isRequired,
}
